enum RoleType {
    Member = 'Member',
    HR_Recruiter = 'HR Recruiter',
    Super_Admin = 'Super Admin',
    Support = 'Support',
    Employer = 'Employer'
}

export default RoleType;